/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Employee-timeEntryGrid--detail tr td:nth-child(2),.Employee-timeEntryGrid--detail tr th:nth-child(2){border-left:0}.approval-grid-icon .iconButton,.approval-grid-icon app-icon,.approval-grid-icon div,.approval-grid-icon span.IconContainer--flex{display:flex;align-items:center;justify-content:center}.approval-grid-icon app-icon{line-height:0}.flexContainer .FormElement-static{display:flex;align-items:center;justify-content:center}"];
export { styles as styles };
